export const sum = (numbers: number[]) =>
  numbers.reduce((total, aNumber) => total + aNumber, 0)

export const average = (numbers: number[]) => sum(numbers) / numbers.length

export const regexPriceWithComma = RegExp(/^[+]?([,|.]\d+|\d+([,|.]\d+)?)$/)
